import { SerializedStyles, css } from "@emotion/react";
import Link from "next/link";
import { FC } from "react";

import Color from "~/lib/client/design";
import { formatDate } from "~/lib/graphql/graphqlClient";

type Database = {
  id: number;
  title: string;
  createdAt: string;
  categories: { id: number; name: string }[];
  postSize: number;
};

type Props = {
  database: Database;
  cssProps?: SerializedStyles;
};

const MobileDatabasePanel: FC<Props> = ({
  database: { id, title, createdAt, categories, postSize },
  cssProps,
}) => {
  return (
    <div css={[rootStyle, cssProps]}>
      <div>
        <Link href={`/database/${id}`}>
          <p>{title}</p>
        </Link>
      </div>
      <div
        css={css`
          width: 100%;
        `}
      >
        <div css={categoriesStyle}>
          {categories.map((category) => (
            <Link
              key={`category-${category.id}`}
              href={`/category/${category.id}`}
              css={categoryNameContainerStyle}
            >
              <div>#{category.name}</div>
            </Link>
          ))}
        </div>
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            width: 100%;
            font-size: 12px;
            color: ${Color.character.subSentence};
          `}
        >
          <div>{postSize} posts</div>
          <div>{formatDate(createdAt)}</div>
        </div>
      </div>
    </div>
  );
};

const rootStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 8px 16px 8px 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  color: ${Color.character.sentence};
  width: 100%;
`;

const categoriesStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  font-size: small;
  color: ${Color.character.subSentence};
`;

const categoryNameContainerStyle = css`
  margin: 0 0 0 4px;
`;

export default MobileDatabasePanel;
